import {
  Directive,
  inject,
  Input,
  OnInit,
  ViewContainerRef,
} from '@angular/core';
import { from, take } from 'rxjs';

export interface ComponentSwitcherConfigOptions {
  [name: string]: any;
}

export interface ComponentSwitcherConfig {
  component: () => Promise<any>;
  data: any;
  options?: ComponentSwitcherConfigOptions;
}

@Directive({
  selector: '[nxMassaudComponentSwitcher]',
  standalone: true,
})
export class ComponentSwitcherDirective implements OnInit {
  private viewContainer = inject(ViewContainerRef);

  @Input('nxMassaudComponentSwitcher') config:
    | ComponentSwitcherConfig
    | undefined;

  ngOnInit(): void {
    if (this.config) {
      from(this.config.component())
        .pipe(take(1))
        .subscribe((component) => {
          this.viewContainer.clear();
          if (component) {
            const componentRef = this.viewContainer.createComponent(component);
            componentRef.setInput('data', this.config?.data);
            componentRef.changeDetectorRef.detectChanges();
          }
        });
    }
  }
}
